import { connectToGadget } from './src/containers/gadget-connector';

export { DateFormatProvider, DateFormatContext, useDateFormatContext } from './src/containers/date-format-provider';

connectToGadget();